import React from "react";
import logical from "./logo.svg";

const Logo = () => (
  <view>
    <img alt={'logical'} src={logical} height={32} />
  </view>
);

export default Logo;


// WEBPACK FOOTER //
// ./src/layout/Logo.js